var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse, _ellipse2, _ellipse3, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 60,
    viewBox: "0 0 134 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    width: 21.8182,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    y: 10.9082,
    width: 34.5454,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.637,
    y: 1.81836,
    width: 9.09091,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.273,
    y: 25.4551,
    width: 9.09091,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 23.6367,
    width: 36.3636,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 36.3633,
    width: 27.2727,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36.3633,
    width: 32.7273,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.636719,
    y: 49.0898,
    width: 56.3636,
    height: 5.45454,
    rx: 2.72727,
    fill: "#F2F2F2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.7282,
    cy: 10.9098,
    rx: 3.63636,
    ry: 3.63636,
    fill: "#F2F2F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.1823,
    cy: 47.2731,
    rx: 3.63636,
    ry: 3.63636,
    fill: "#F2F2F2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.455,
    cy: 18.1815,
    rx: 1.81818,
    ry: 1.81818,
    fill: "#F2F2F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9096,
    cy: 34.5463,
    r: 25.4545,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1299 26.209V34.4935M67.1299 42.7779H67.1506",
    stroke: "#949DA6",
    strokeWidth: 6.30414,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableIcon);
export default __webpack_public_path__ + "static/media/disable-icon.b6abe65873c52ad2343b07b3aa1ef835.svg";
export { ForwardRef as ReactComponent };